import React from "react";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ProcessingStatusLabel from "./ProcessingStatusLabel";
import Guard from "components/Guard/Guard";
import { css } from "@emotion/react";
import ProcessingStatusAlert from "./ProcessingStatusAlert";
import { useTranslation } from "react-i18next";
import { useDocumentProcessingStatus } from "./functions/useDocumentProcessingStatus";

type Props = {
  applicationId: number;
  documentContainerId: number;
};

const DocumentProcessingStatus: React.FC<Props> = ({ documentContainerId, applicationId }) => {
  const { t } = useTranslation();
  const { isIntelligenceAlertVisible, isProcessingStatusVisible } = useDocumentProcessingStatus({
    documentContainerId,
    applicationId,
  });

  if (!isIntelligenceAlertVisible && !isProcessingStatusVisible) {
    return null;
  }

  return (
    <StyledList data-testid={"DocumentProcessingStatus"}>
      <Guard condition={isProcessingStatusVisible}>
        <ProcessingStatusLabel statusLabel={t`Analysing Document`} isLoading={true} />
      </Guard>

      <Guard condition={isIntelligenceAlertVisible}>
        <ProcessingStatusAlert
          primaryText={t("Information was automatically extracted from your document")}
          secondaryText={t("Please review and edit if needed before submitting your application.")}
        />
      </Guard>
    </StyledList>
  );
};

const StyledList = styled(List)(
  ({ theme }) => css`
    border-radius: 4px;
    margin-bottom: 0 !important;
  `
);

export default DocumentProcessingStatus;
